import Vue from 'vue'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import config from '@/config'

const initState = {
  authToken: null,
  lastTokenRefreshAt: null,
  lastActionAt: null,
  tokenExpireInMinutes: null,
  userData: null,
  userTenantId: null,
}

function getInitialState (reset = false) {
  Object.keys(initState)
    .map(k => {
      initState[k] = config.KEEP_LOGGED_IN && !reset
        ? Vue.localStorage.get(k, null)
        : null
    })

  if (initState.userData && typeof initState.userData === 'string') {
    initState.userData = JSON.parse(initState.userData)
  }

  return initState
}

mutations.RESET = (state) => {
  const state_ = getInitialState(true)

  Object
    .keys(state_)
    .map(key => {
      state[key] = state_[key]
    })

  Object
    .keys(initState)
    .map(k => Vue.localStorage.remove(k))
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations
}
